"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RE = __importStar(require("@raydiant/playlist-rule-engine"));
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var uuid_1 = require("uuid");
var embeddedApps_1 = __importDefault(require("./embeddedApps"));
var PlaylistWindowManager_1 = __importDefault(require("./PlaylistWindowManager"));
var WindowTimeoutError_1 = __importDefault(require("./WindowTimeoutError"));
var WindowLoadError_1 = __importDefault(require("./WindowLoadError"));
// TODO: Automatically inject latest version when building in CI.
var defaultAppRendererUrl = 'https://apps.raydiant.com/3.1.0/index.html';
var isValidNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
var isValidAnalyticsEvent = function (value) {
    return value &&
        typeof value === 'object' &&
        typeof value.type === 'string' &&
        typeof value.source === 'string' &&
        (typeof value.productCategory === 'string' ||
            value.productCategory === undefined ||
            value.productCategory === null);
};
var isValidChargeRequest = function (value) {
    return value &&
        typeof value === 'object' &&
        typeof value.requestId === 'string' &&
        typeof value.subTotal === 'number' &&
        typeof value.tip === 'number' &&
        typeof value.tax === 'number' &&
        typeof value.total === 'number';
};
var isValidAcquireLockRequest = function (value) {
    return value && typeof value === 'object' && typeof value.requestId === 'string';
};
var isValidRenewLockRequest = function (value) {
    return value &&
        typeof value === 'object' &&
        typeof value.requestId === 'string' &&
        typeof value.lockId === 'string';
};
var isValidReleaseLockRequest = function (value) {
    return value &&
        typeof value === 'object' &&
        typeof value.requestId === 'string' &&
        typeof value.lockId === 'string';
};
var lockDuration = 1000 * 60; // 1 minute
var PresentationWindow = /** @class */ (function () {
    function PresentationWindow(options) {
        var _this = this;
        this.options = options;
        this.didReceiveReady = false;
        this.readyCallback = null;
        this.didReceiveComplete = false;
        this.completeCallback = null;
        this.errorCallback = null;
        this.readyTimeout = null;
        this.windowManagers = {};
        this.focusedWindowManager = null;
        this.didEmbeddedAppLoad = false;
        this.lastPlayedAt = null;
        this.configurableDurationTimeout = null;
        this.isWindowLocked = false;
        this.isChildWindowLocked = {};
        this.enableInterruptLockCallback = null;
        this.disableInterruptLockCallback = null;
        this.analyticsEventCallback = null;
        this.chargeRequestCallback = null;
        this.forceMute = false;
        this.error = null;
        this.workerState = {};
        this.workerSubscriptions = new Set();
        this.runtimeSubscriptions = new Set();
        this.previewSubscriptions = new Set();
        this.previewState = { inputs: {} };
        this.paymentSubscriptions = new Set();
        this.createObjectURLResolvers = {};
        this.createObjectURLTimeouts = {};
        this.interruptLocks = {};
        this.previouslyLocked = false;
        this.handleEmbeddedMessage = function (type, payload) { return __awaiter(_this, void 0, void 0, function () {
            var windowId, workerState, lock, lock, lock;
            return __generator(this, function (_a) {
                windowId = this.options.windowId;
                switch (type) {
                    case 'ready': {
                        this.logInfo("Received 'ready' from window '".concat(windowId, "'"));
                        this.handleReady();
                        break;
                    }
                    case 'complete': {
                        if (payload === undefined) {
                            this.logInfo("Received 'complete' from window '".concat(windowId, "'"));
                            this.handleComplete();
                        }
                        else {
                            this.logInfo("Received 'complete' with error from window '".concat(windowId, ", error=").concat(payload, "'"));
                            this.handleError(payload);
                        }
                        break;
                    }
                    case 'runtime-subscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'runtime-subscribe' from window '".concat(windowId, "'"));
                            // The payload is the event name (ex. 'play').
                            this.runtimeSubscriptions.add(payload);
                            // Immediately send play if the app if already playing.
                            if (this.isPlaying()) {
                                this.sendMessageString('play');
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for runtime-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'runtime-unsubscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'runtime-unsubscribe' from window '".concat(windowId, "'"));
                            // The payload is the event name (ex. 'play').
                            this.runtimeSubscriptions.delete(payload);
                        }
                        else {
                            this.logWarning("Invalid payload for runtime-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'worker-subscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'worker-subscribe' from window '".concat(windowId, "'"));
                            // The payload is the worker name.
                            this.workerSubscriptions.add(payload);
                            workerState = this.workerState[payload];
                            if (workerState !== undefined) {
                                this.sendMessageString('worker-state', {
                                    name: payload,
                                    state: workerState,
                                });
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for worker-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'worker-unsubscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'worker-unsubscribe' from window '".concat(windowId, "'"));
                            // The payload is the worker name.
                            this.workerSubscriptions.delete(payload);
                        }
                        else {
                            this.logWarning("Invalid payload for worker-unsubscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'analytics-event': {
                        if (isValidAnalyticsEvent(payload)) {
                            if (this.analyticsEventCallback) {
                                this.analyticsEventCallback(payload);
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for analytics-event message: ".concat(payload));
                        }
                        break;
                    }
                    case 'create-object-url-result': {
                        if (isValidCreateObjectURLResultPayload(payload)) {
                            // Resolve promise with the local blob URL.
                            if (this.createObjectURLResolvers[payload.requestId]) {
                                this.createObjectURLResolvers[payload.requestId](payload.url);
                                delete this.createObjectURLResolvers[payload.requestId];
                            }
                            // Clear the timeout for the request.
                            if (this.createObjectURLTimeouts[payload.requestId]) {
                                clearTimeout(this.createObjectURLTimeouts[payload.requestId]);
                                delete this.createObjectURLTimeouts[payload.requestId];
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for create-object-url-result message: ".concat(payload));
                        }
                        break;
                    }
                    case 'preview-subscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'preview-subscribe' from window '".concat(windowId, "'"));
                            // The payload is the event name (ex. 'inputs').
                            this.previewSubscriptions.add(payload);
                        }
                        else {
                            this.logWarning("Invalid payload for preview-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'preview-unsubscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'preview-unsubscribe' from window '".concat(windowId, "'"));
                            // The payload is the event name (ex. 'inputs').
                            this.previewSubscriptions.delete(payload);
                        }
                        else {
                            this.logWarning("Invalid payload for preview-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'payments-charge-request': {
                        if (isValidChargeRequest(payload)) {
                            if (this.chargeRequestCallback) {
                                this.chargeRequestCallback(payload);
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for payments-charge-request message: ".concat(payload));
                        }
                        break;
                    }
                    case 'payments-subscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'worker-subscribe' from window '".concat(windowId, "'"));
                            // The payload is the payment subscription type (ex. 'charge', 'terminal')
                            this.paymentSubscriptions.add(payload);
                            // Immediately send terminal when subscribing.
                            if (payload === 'terminal' && this.options.getTerminal) {
                                this.sendMessageObject('payments-terminal-event', {
                                    terminal: this.options.getTerminal(),
                                });
                            }
                        }
                        else {
                            this.logWarning("Invalid payload for payments-subscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'payments-unsubscribe': {
                        if (typeof payload === 'string') {
                            this.logInfo("Received 'payments-unsubscribe' from window '".concat(windowId, "'"));
                            this.paymentSubscriptions.delete(payload);
                        }
                        else {
                            this.logWarning("Invalid payload for payments-unsubscribe message: ".concat(payload));
                        }
                        break;
                    }
                    case 'runtime-acquire-interrupt-lock-request': {
                        if (isValidAcquireLockRequest(payload)) {
                            this.logInfo("Received 'runtime-acquire-interrupt-lock-request'");
                            lock = this.createInterruptLock();
                            this.sendMessageObject('runtime-acquire-interrupt-lock-response', {
                                requestId: payload.requestId,
                                lock: { id: lock.id, expiresAt: lock.expiresAt },
                            });
                        }
                        else {
                            this.logWarning("Invalid payload for runtime-acquire-interrupt-lock-request message: ".concat(payload));
                        }
                        break;
                    }
                    case 'runtime-renew-interrupt-lock-request': {
                        if (isValidRenewLockRequest(payload)) {
                            this.logInfo("Received 'runtime-renew-interrupt-lock-request'");
                            lock = this.renewInterruptLock(payload.lockId);
                            this.sendMessageObject('runtime-renew-interrupt-lock-response', {
                                requestId: payload.requestId,
                                lock: { id: lock.id, expiresAt: lock.expiresAt },
                            });
                        }
                        else {
                            this.logWarning("Invalid payload for runtime-renew-interrupt-lock-request message: ".concat(payload));
                        }
                        break;
                    }
                    case 'runtime-release-interrupt-lock-request': {
                        if (isValidReleaseLockRequest(payload)) {
                            this.logInfo("Received 'runtime-release-interrupt-lock-request'");
                            lock = this.releaseInterruptLock(payload.lockId);
                            this.sendMessageObject('runtime-release-interrupt-lock-response', {
                                requestId: payload.requestId,
                                lock: { id: lock.id, expiresAt: lock.expiresAt },
                            });
                        }
                        else {
                            this.logWarning("Invalid payload for runtime-release-interrupt-lock-request message: ".concat(payload));
                        }
                        break;
                    }
                    default: {
                        this.logWarning("Received unknown embedded message type: ".concat(type));
                    }
                }
                return [2 /*return*/];
            });
        }); };
        this.handleLegacyMessage = function (type, payload) { return __awaiter(_this, void 0, void 0, function () {
            var _a, windowId, onPresentationProperties;
            return __generator(this, function (_b) {
                _a = this.options, windowId = _a.windowId, onPresentationProperties = _a.onPresentationProperties;
                if (type === 'loaded') {
                    this.logInfo("Received 'loaded' from window '".concat(windowId, "'"));
                    this.sendRenderMessage();
                }
                if (type === 'presentation_ready') {
                    this.logInfo("Received 'presentation_ready' from window '".concat(windowId, "'"));
                    this.handleReady();
                }
                if (type === 'presentation_complete') {
                    this.logInfo("Received 'presentation_complete' from window '".concat(windowId, "'"));
                    this.handleComplete();
                }
                if (type === 'enable_interrupt_lock') {
                    this.logInfo("Received 'enable_interrupt_lock' from window '".concat(windowId, "'"));
                    this.enableInteruptLock();
                }
                if (type === 'disable_interrupt_lock') {
                    this.logInfo("Received 'disable_interrupt_lock' from window '".concat(windowId, "'"));
                    this.disableInteruptLock();
                }
                if (type === 'open_child_window') {
                    this.logInfo("Received 'open_child_window' from window '".concat(windowId, "', windowId=").concat(payload.windowId, " playlistId=").concat(payload.playlistId, " isMuted=").concat(payload.isMuted, " x=").concat(payload.x, " y=").concat(payload.y, " width=").concat(payload.width, " height=").concat(payload.height));
                    if (this.isValidOpenChildWindowPayload(payload)) {
                        this.openChildWindow(payload.windowId, payload.playlistId, {
                            x: Math.round(payload.x),
                            y: Math.round(payload.y),
                            width: Math.round(payload.width),
                            height: Math.round(payload.height),
                        }, payload.isMuted, payload.isFocused, payload.theme);
                    }
                    else {
                        this.logWarning("Invalid payload received for 'open_child_window', ignoring");
                    }
                }
                if (type === 'close_child_window') {
                    // TODO: Validate close_child_window message payload.
                    this.logInfo("Received 'close_child_window', windowId=".concat(payload.windowId));
                    this.closeChildWindow(payload.windowId);
                }
                if (type === 'log_error') {
                    this.handleError("Received error from window '".concat(windowId, "', error=").concat(JSON.stringify(payload)));
                }
                if (type === 'log_info') {
                    this.logInfo("Received info log from window '".concat(windowId, "', message=").concat(JSON.stringify(payload)));
                }
                if (type === 'log_debug') {
                    this.logDebug("Received info debug from window '".concat(windowId, "', message=").concat(JSON.stringify(payload)));
                }
                if (type === 'presentation_properties') {
                    this.logInfo("Received 'presentation_properties' from window '".concat(windowId, "'"));
                    if (onPresentationProperties) {
                        onPresentationProperties(payload.properties, payload.strings);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        this.handleError = function (error) {
            _this.error = error;
            var message = error instanceof Error ? error.message : error;
            _this.logError(message);
            if (_this.errorCallback) {
                _this.errorCallback(error);
            }
        };
        this.builderState = options.builderState;
        this.presentation = options.presentation;
        this.playlistWindowManagerState = options.playlistWindowManagerState;
        this.ruleEngineState = options.ruleEngineState;
        this.theme = options.theme;
        this.forceMute = options.forceMute || false;
        this.workerState = options.workerState;
    }
    PresentationWindow.prototype.load = function () {
        if (this.isEmbeddedApp()) {
            return this.loadEmbeddedApp();
        }
        return this.loadLegacyApp();
    };
    PresentationWindow.prototype.show = function (isFocused) {
        var _this = this;
        if (isFocused === void 0) { isFocused = true; }
        var _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
        // Show the main window and focus it before any child windows. Showing a child
        // window that requires focus will move focus from the main window to the child.
        renderer.showWindow(windowId, isFocused);
        // Windows are created muted, check if we should unmute the window when showing.
        // This ensures presentations that use audio take precendence over SYB playback on device.
        // This checks the presentation for mute properties when shown but does not handle the case
        // when an app becomes unmuted or muted while running (ie. someone interacting with a video player).
        // A possible better solution would be to have apps fire an event when they need audio.
        var isMuted = this.shouldMute();
        if (!isMuted) {
            renderer.unMuteWindow(windowId);
        }
        // Show child windows after main window, setting focus if necessary.
        var isChildWindowFocused = false;
        Object.values(this.windowManagers).map(function (wm) {
            if (isFocused &&
                _this.focusedWindowManager &&
                _this.focusedWindowManager === wm) {
                isChildWindowFocused = true;
                wm.show(true);
            }
            else {
                wm.show(false);
            }
        });
        this.logInfo("Show window '".concat(windowId, "' isMuted=").concat(isMuted, " isFocused=").concat(isFocused).concat(isChildWindowFocused ? " isChildWindowFocused=true" : ''));
    };
    PresentationWindow.prototype.hide = function () {
        var _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
        // Hide child windows before main window.
        Object.values(this.windowManagers).map(function (wm) { return wm.hide(); });
        renderer.hideWindow(windowId);
    };
    PresentationWindow.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, renderer, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
                        // Clean up callbacks
                        this.readyCallback = null;
                        this.completeCallback = null;
                        this.errorCallback = null;
                        this.enableInterruptLockCallback = null;
                        this.disableInterruptLockCallback = null;
                        // Clean up subscriptions
                        this.workerSubscriptions.clear();
                        // Clear timers
                        if (this.readyTimeout) {
                            clearTimeout(this.readyTimeout);
                            this.readyTimeout = null;
                        }
                        if (this.configurableDurationTimeout) {
                            clearTimeout(this.configurableDurationTimeout);
                            this.configurableDurationTimeout = null;
                        }
                        // Remove any child window managers.
                        Object.values(this.windowManagers).forEach(function (wm) {
                            wm.destroy();
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, renderer.removeWindow(windowId)];
                    case 2:
                        _b.sent();
                        this.logInfo("Removed window '".concat(windowId, "'"));
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.logError("Failed to remove window '".concat(windowId, "' with '").concat(err_1.message, "'"));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Method to modify the rule engine state for the inner playlist windows (called from outer playlist window manager)
    PresentationWindow.prototype.reinitializePresentationWindowRuleEngineState = function (newRulesDataStoreObj) {
        Object.values(this.windowManagers).forEach(function (wm) {
            wm.reinitializeRuleEngineState(newRulesDataStoreObj);
        });
    };
    PresentationWindow.prototype.play = function () {
        var _this = this;
        var _a = this.options, applicationVersion = _a.applicationVersion, presentation = _a.presentation;
        if (applicationVersion.configurableDuration) {
            var durationMs = Math.max(presentation.duration * 1000, 5000);
            if (this.configurableDurationTimeout) {
                clearTimeout(this.configurableDurationTimeout);
            }
            this.configurableDurationTimeout = setTimeout(function () {
                if (_this.completeCallback) {
                    _this.completeCallback();
                }
            }, durationMs);
        }
        if (!this.isEmbeddedApp()) {
            this.sendMessageString('play');
            // Play any child window managers.
            Object.values(this.windowManagers).forEach(function (wm) {
                // We only want to trigger play on child windows the first play of the main window or if
                // the child window is paused.
                if (!wm.isPlaying() || wm.isPaused()) {
                    wm.play();
                }
            });
        }
        else if (this.runtimeSubscriptions.has('play')) {
            // If the embedded app has subscribed to the play event, send it a play event.
            this.sendMessageString('play');
        }
        this.lastPlayedAt = new Date();
    };
    PresentationWindow.prototype.pause = function () {
        // Pause all child window managers.
        Object.values(this.windowManagers).forEach(function (wm) { return wm.pause(); });
    };
    PresentationWindow.prototype.resume = function () {
        // Resume all child window managers.
        Object.values(this.windowManagers).forEach(function (wm) { return wm.resume(); });
    };
    PresentationWindow.prototype.reset = function () {
        this.didReceiveComplete = false;
    };
    PresentationWindow.prototype.onComplete = function (callback) {
        this.completeCallback = callback;
    };
    PresentationWindow.prototype.onError = function (callback) {
        this.errorCallback = callback;
    };
    PresentationWindow.prototype.onEnableInterruptLock = function (callback) {
        this.enableInterruptLockCallback = callback;
    };
    PresentationWindow.prototype.onDisableInterruptLock = function (callback) {
        this.disableInterruptLockCallback = callback;
    };
    PresentationWindow.prototype.onAnalyticsEvent = function (callback) {
        this.analyticsEventCallback = callback;
    };
    PresentationWindow.prototype.onChargeRequest = function (callback) {
        this.chargeRequestCallback = callback;
    };
    PresentationWindow.prototype.isReady = function () {
        // TODO: To support the 'ready' event in embedded apps, they will need to tell the
        // runtime that it should wait for ready instead of DOMLoaded. This could be a "wait
        // for ready"  option in the Developer Portal.
        if (this.isEmbeddedApp()) {
            return this.didEmbeddedAppLoad;
        }
        return this.didReceiveReady && this.allChildWindowManagersReady();
    };
    PresentationWindow.prototype.isComplete = function () {
        return this.didReceiveComplete;
    };
    PresentationWindow.prototype.isPlaying = function () {
        return this.lastPlayedAt !== null;
    };
    PresentationWindow.prototype.updateBounds = function (bounds) {
        var _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
        renderer.updateWindowBounds(windowId, bounds);
    };
    PresentationWindow.prototype.didError = function () {
        return !!this.error;
    };
    PresentationWindow.prototype.isLocked = function () {
        // Legacy check for a lock on the current window or child windows. These are set by enableInterruptLock
        // and disableInterruptLock, which are only used by RaydiantKit apps (ie. Virtual Rooms).
        if (this.isWindowLocked) {
            this.logDebug("Window '".concat(this.options.windowId, "' is locked due to enableInterruptLock"));
            return true;
        }
        if (Object.values(this.isChildWindowLocked).some(Boolean)) {
            this.logDebug("Window '".concat(this.options.windowId, "' is locked due to enableInterruptLock on child windows"));
            return true;
        }
        // Check interrupt locks on current window or child windows, used by embedded apps (apps created through
        // the Developer Portal).
        var now = +new Date();
        var isExpired = function (lock) { return lock.expiresAt < now; };
        if (!Object.values(this.interruptLocks).every(isExpired)) {
            this.logDebug("Window '".concat(this.options.windowId, "' is locked due to interrupt lock"));
            return true;
        }
        if (Object.values(this.windowManagers).some(function (wm) { return wm.isLocked(); })) {
            this.logDebug("Window '".concat(this.options.windowId, "' is locked due to interrupt lock on child windows"));
            return true;
        }
        return false;
    };
    PresentationWindow.prototype.setPresentation = function (presentation, playlistWindowManagerState, ruleEngineState) {
        this.presentation = presentation;
        this.ruleEngineState = ruleEngineState;
        this.playlistWindowManagerState = playlistWindowManagerState;
    };
    PresentationWindow.prototype.setTheme = function (theme) {
        this.theme = theme;
    };
    PresentationWindow.prototype.setBuilderState = function (builderState) {
        this.builderState = builderState;
    };
    PresentationWindow.prototype.setForceMute = function (forceMute) {
        this.forceMute = forceMute;
    };
    PresentationWindow.prototype.reload = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, applicationVersion, windowId, updatedInputs, url;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this.options, applicationVersion = _b.applicationVersion, windowId = _b.windowId;
                        if (!this.isEmbeddedApp()) return [3 /*break*/, 4];
                        if (!applicationVersion.embeddedUrlFormat) return [3 /*break*/, 3];
                        if (!this.previewSubscriptions.has('inputs')) return [3 /*break*/, 1];
                        this.logInfo("Reload window '".concat(windowId, "' for embedded app preview state"));
                        updatedInputs = transformInputValues(this.presentation.applicationVariables);
                        // Add metadata to inputs if they exist in the URL template. These need to be
                        // consistent with metadata keys in embeddedApps.ts.
                        if (applicationVersion.embeddedUrlFormat.includes(':$renderMode')) {
                            updatedInputs['$renderMode'] = this.getRenderMode();
                        }
                        if (applicationVersion.embeddedUrlFormat.includes(':$token')) {
                            updatedInputs['$token'] = this.presentation.token;
                        }
                        if (applicationVersion.embeddedUrlFormat.includes(':$deviceId')) {
                            updatedInputs['$deviceId'] = (_a = this.options.device) === null || _a === void 0 ? void 0 : _a.id;
                        }
                        // Send the updated inputs to the embedded app if they have changed.
                        if (!(0, fast_deep_equal_1.default)(updatedInputs, this.previewState.inputs)) {
                            this.sendMessageObject('preview-inputs', updatedInputs);
                        }
                        this.previewState.inputs = updatedInputs;
                        return [3 /*break*/, 3];
                    case 1:
                        url = this.getEmbeddedAppUrl();
                        this.logInfo("Reload window '".concat(windowId, "' for embedded app url '").concat(url, "'"));
                        return [4 /*yield*/, this.loadWindow(url)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.logInfo("Reload window '".concat(windowId, "'"));
                        this.sendRenderMessage();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PresentationWindow.prototype.runGetProperties = function (builderState) {
        // Do no support conditional properties for embedded apps. We will likely
        // change the way conditional properties work.
        if (!this.isEmbeddedApp()) {
            this.sendMessageString('run_get_properties', builderState);
        }
    };
    PresentationWindow.prototype.createObjectURL = function (blob) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isEmbeddedApp()) {
                    return [2 /*return*/, this.createObjectURLForEmbeddedApp(blob)];
                }
                return [2 /*return*/, URL.createObjectURL(blob)];
            });
        });
    };
    PresentationWindow.prototype.sendChargeResponse = function (response) {
        // TODO: Instead of sending the charge to all windows, we should only send it to the app
        // that requested the charge. We probably don't want to use the windowId to avoid missing
        // the events in case the window was closed/restarted. Since we are only sending the charge
        // id and status this seems ok for now but need to be mindful of sending any sensitive data.
        this.sendMessageObject('payments-charge-response', {
            requestId: response.requestId,
            charge: response.charge,
            error: response.error,
        });
        // Forward the event to the child window managers.
        Object.values(this.windowManagers).forEach(function (wm) {
            return wm.sendChargeResponse(response);
        });
    };
    PresentationWindow.prototype.sendCharge = function (charge) {
        // TODO: Instead of sending the charge to all windows, we should only send it to the app
        // that requested the charge.
        if (this.paymentSubscriptions.has('charge')) {
            this.sendMessageObject('payments-charge-event', { charge: charge });
        }
        // Forward the event to the child window managers.
        Object.values(this.windowManagers).forEach(function (wm) { return wm.sendCharge(charge); });
    };
    PresentationWindow.prototype.sendTerminal = function (terminal) {
        if (this.paymentSubscriptions.has('terminal')) {
            this.sendMessageObject('payments-terminal-event', { terminal: terminal });
        }
        // Forward the event to the child window managers.
        Object.values(this.windowManagers).forEach(function (wm) {
            return wm.sendTerminal(terminal);
        });
    };
    PresentationWindow.prototype.isEmbeddedApp = function () {
        var _a = this.options, applicationVersion = _a.applicationVersion, isPreview = _a.isPreview;
        // If the application has a source url, always use it for rendering the preview.
        // This fixes an issue with Hoopla which is an embedded app but uses a legacy app
        // for it's preview.
        if (isPreview && applicationVersion.sourceUrl) {
            return false;
        }
        return !!applicationVersion.embeddedUrlFormat;
    };
    PresentationWindow.prototype.allChildWindowManagersReady = function () {
        // Return true if the presentation doesn't contain any playlists.
        if (this.presentation.r.presentationsPlaylists.length === 0) {
            return true;
        }
        return Object.values(this.windowManagers).every(function (wm) { return wm.isReady(); });
    };
    PresentationWindow.prototype.checkIsReadyCallback = function () {
        if (this.isReady()) {
            if (this.readyTimeout) {
                clearTimeout(this.readyTimeout);
            }
            if (this.readyCallback) {
                this.readyCallback();
            }
            // Trigger the enable interrupt lock callback if the presentation fired
            // enable_interrupt_lock before presentation_ready.
            if (this.isLocked() && this.enableInterruptLockCallback) {
                this.enableInterruptLockCallback();
            }
        }
    };
    PresentationWindow.prototype.getFullAppRendererUrl = function (_a) {
        var appRendererUrl = _a.appRendererUrl, windowId = _a.windowId, appRendererOfflineSupport = _a.appRendererOfflineSupport;
        var url = new URL(appRendererUrl);
        var hashParams = new URLSearchParams(url.hash.slice(1));
        hashParams.set('__raydiantWindowId', windowId);
        if (appRendererOfflineSupport === true) {
            hashParams.set('__raydiantOfflineSupport', 'true');
        }
        url.hash = hashParams.toString();
        return url.toString();
    };
    PresentationWindow.prototype.loadEmbeddedApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, applicationVersion, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, applicationVersion = _a.applicationVersion;
                        if (!applicationVersion.embeddedUrlFormat) {
                            throw new Error("Error loading embedded app, missing embeddedUrlFormat for '".concat(applicationVersion.id, "'"));
                        }
                        url = this.getEmbeddedAppUrl();
                        this.logInfo("Create window '".concat(windowId, "' for embedded app url '").concat(url, "'"));
                        return [4 /*yield*/, this.createAndLoadWindow(url, 
                            // Embedded apps should not have a backgroundColor because some sites expect
                            // the browser default of white will be applied.
                            '#ffffff', this.handleEmbeddedMessage)];
                    case 1:
                        _b.sent();
                        this.didEmbeddedAppLoad = true;
                        this.checkIsReadyCallback();
                        return [2 /*return*/];
                }
            });
        });
    };
    PresentationWindow.prototype.loadLegacyApp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, _b, appRendererUrl, appRendererOfflineSupport, backgroundColor;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, _b = _a.appRendererUrl, appRendererUrl = _b === void 0 ? defaultAppRendererUrl : _b, appRendererOfflineSupport = _a.appRendererOfflineSupport, backgroundColor = _a.backgroundColor;
                        this.logInfo("Create window '".concat(windowId, "'"));
                        return [4 /*yield*/, this.createAndLoadWindow(this.getFullAppRendererUrl({
                                appRendererUrl: appRendererUrl,
                                windowId: windowId,
                                appRendererOfflineSupport: appRendererOfflineSupport,
                            }), backgroundColor || '#000000', // Default to black bg for Raydiant apps
                            this.handleLegacyMessage)];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.waitForPesentationReady()];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PresentationWindow.prototype.createAndLoadWindow = function (url, backgroundColor, receiveMessageCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, parentWindowId, renderer, bounds;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, parentWindowId = _a.parentWindowId, renderer = _a.renderer, bounds = _a.bounds;
                        renderer.createWindow({
                            windowId: windowId,
                            parentWindowId: parentWindowId,
                            bounds: bounds,
                            backgroundColor: backgroundColor,
                            receiveMessageCallback: receiveMessageCallback,
                            errorCallback: this.handleError,
                        });
                        // Mute new window. This ensures preloaded windows are muted by default and
                        // prevents opening an audio channel on the device for SYB playback. When using
                        // the BrowserWindowRenderer this will call setAudioMuted(true) but the IFrameRenderer
                        // has no API for muting so we rely on apps that use mute presentation props to be
                        // initially muted before playing.
                        this.logInfo("Mute window ".concat(windowId));
                        renderer.muteWindow(windowId);
                        return [4 /*yield*/, this.loadWindow(url)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PresentationWindow.prototype.loadWindow = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, renderer, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, renderer.loadWindow(windowId, url)];
                    case 2:
                        _b.sent();
                        this.logInfo("Loaded window '".concat(windowId, "'"));
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        this.handleError(new WindowLoadError_1.default("Failed to load window with '".concat(err_2.message, "'")));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Send a JSON stringified message to the renderer. This is the legacy way of sending
    // messages and should be deprecated in favor of sendMessageObject.
    PresentationWindow.prototype.sendMessageString = function (type, payload) {
        var _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
        var message = JSON.stringify({ type: type, payload: payload, windowId: windowId });
        this.logInfo("Sending '".concat(type, "' to window '").concat(windowId, "'"));
        renderer.sendMessageString(windowId, message);
    };
    // Send a message object to the renderer. This is the preferred way of sending messages
    // going forward since it allows for more complex payloads like ArrayBuffers (for File Inputs).
    PresentationWindow.prototype.sendMessageObject = function (type, payload) {
        var _a = this.options, windowId = _a.windowId, renderer = _a.renderer;
        this.logInfo("Sending '".concat(type, "' to window '").concat(windowId, "'"));
        renderer.sendMessageObject(windowId, type, payload);
    };
    PresentationWindow.prototype.waitForPesentationReady = function () {
        var _this = this;
        var _a = this.options, windowId = _a.windowId, _b = _a.readyTimeoutDurationSeconds, readyTimeoutDurationSeconds = _b === void 0 ? 30 : _b;
        return new Promise(function (resolve) {
            if (_this.didReceiveReady) {
                resolve();
            }
            else {
                _this.readyCallback = function () {
                    resolve();
                };
                if (_this.readyTimeout) {
                    clearTimeout(_this.readyTimeout);
                }
                _this.readyTimeout = setTimeout(function () {
                    _this.handleError(new WindowTimeoutError_1.default("Window ".concat(windowId, " timed out after ").concat(readyTimeoutDurationSeconds, " seconds")));
                    // Resolve the promise is the window times out. This ensures windowManager.load() resolves
                    // even if the current window times out. Fixes an issue where the boot screen isn't removed
                    // if the first presentation times out.
                    resolve();
                }, readyTimeoutDurationSeconds * 1000);
            }
        });
    };
    PresentationWindow.prototype.buildTheme = function () {
        if (!this.theme)
            return;
        var nextTheme = __assign({}, this.theme);
        if (nextTheme.headingFontNew && nextTheme.headingFontNew.fileUpload) {
            nextTheme.headingFont =
                nextTheme.headingFontNew.fileUpload.url || nextTheme.headingFont;
        }
        if (nextTheme.heading2FontNew && nextTheme.heading2FontNew.fileUpload) {
            nextTheme.heading2Font =
                nextTheme.heading2FontNew.fileUpload.url || nextTheme.heading2Font;
        }
        if (nextTheme.bodyFontNew && nextTheme.bodyFontNew.fileUpload) {
            nextTheme.bodyFont =
                nextTheme.bodyFontNew.fileUpload.url || nextTheme.bodyFont;
        }
        if (nextTheme.backgroundImageFileUpload) {
            nextTheme.backgroundImage =
                nextTheme.backgroundImageFileUpload.url || nextTheme.backgroundImage;
        }
        return nextTheme;
    };
    PresentationWindow.prototype.sendRenderMessage = function () {
        var _a = this.options, applicationVersion = _a.applicationVersion, isPreview = _a.isPreview, device = _a.device;
        // IFrames do not have a mute/unmute API so we are overriding any mute properties
        // to support muting MZ zones when using the IFrameRenderer (SecondScreen).
        if (this.forceMute) {
            this.sendMessageString('render', {
                builderState: this.builderState,
                presentation: __assign(__assign({}, this.presentation), { applicationVariables: __assign(__assign({}, this.presentation.applicationVariables), { 
                        // TODO: We need a better way to identify mute properties (ie. PropType.mute())
                        // Force mute the presentation, existing apps use either mute or muted.
                        mute: true, muted: true }) }),
                theme: this.buildTheme(),
                applicationVersion: applicationVersion,
                device: device,
                isPreview: isPreview,
            });
        }
        else {
            this.sendMessageString('render', {
                builderState: this.builderState,
                presentation: this.presentation,
                theme: this.buildTheme(),
                applicationVersion: applicationVersion,
                device: device,
                isPreview: isPreview,
            });
        }
    };
    PresentationWindow.prototype.openChildWindow = function (windowName, playlistId, bounds, forceMute, isFocused, themeOverride) {
        if (forceMute === void 0) { forceMute = false; }
        if (isFocused === void 0) { isFocused = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, windowId, renderer, device, readyTimeoutDurationSeconds, appRendererUrl, logger, isPreview, parentWindowManager, windowManager, prevBounds, prevThemeOverride, prevRuleEngine, prevForceMute, didBoundsChange, didForceMuteChange, didThemeOverrideChange, didPlaylistChange;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, windowId = _a.windowId, renderer = _a.renderer, device = _a.device, readyTimeoutDurationSeconds = _a.readyTimeoutDurationSeconds, appRendererUrl = _a.appRendererUrl, logger = _a.logger, isPreview = _a.isPreview;
                        parentWindowManager = this.options.windowManager;
                        windowManager = this.windowManagers[windowName];
                        if (!windowManager) return [3 /*break*/, 1];
                        prevBounds = windowManager.getBounds();
                        prevThemeOverride = windowManager.getThemeOverride();
                        prevRuleEngine = windowManager.getRuleEngine();
                        prevForceMute = windowManager.getForceMute();
                        didBoundsChange = prevBounds
                            ? !(0, fast_deep_equal_1.default)(bounds, prevBounds)
                            : true;
                        if (didBoundsChange) {
                            windowManager.updateBounds(bounds);
                        }
                        didForceMuteChange = forceMute !== prevForceMute;
                        didThemeOverrideChange = prevThemeOverride
                            ? !(0, fast_deep_equal_1.default)(themeOverride, prevThemeOverride)
                            : true;
                        if (didForceMuteChange || didThemeOverrideChange) {
                            windowManager.setThemeOverride(themeOverride);
                            windowManager.setForceMute(forceMute);
                            windowManager.reload();
                        }
                        didPlaylistChange = prevRuleEngine
                            ? playlistId !== prevRuleEngine.playlistId
                            : true;
                        if (didPlaylistChange) {
                            windowManager.reinitialize(this.playlistWindowManagerState, this.createRuleEngine(playlistId), true);
                        }
                        return [3 /*break*/, 3];
                    case 1:
                        windowManager = new PlaylistWindowManager_1.default({
                            parentWindowId: windowId,
                            windowName: windowName,
                            ruleEngine: this.createRuleEngine(playlistId),
                            state: this.playlistWindowManagerState,
                            logger: logger,
                            device: device,
                            readyTimeoutDurationSeconds: readyTimeoutDurationSeconds,
                            appRendererUrl: appRendererUrl,
                            bounds: {
                                x: bounds.x,
                                y: bounds.y,
                                width: bounds.width,
                                height: bounds.height,
                            },
                            backgroundColor: 'transparent',
                            themeOverride: themeOverride,
                            forceMute: forceMute,
                            isPreview: isPreview,
                            onEnableInterruptLock: function () {
                                // enableInterruptLock is only used by legacy RaydiantKit apps (ie. Virtual Rooms), while
                                // runInterruptCallback is used by Developer Portal apps.
                                if (_this.isEmbeddedApp()) {
                                    _this.runInterruptCallback();
                                }
                                else {
                                    _this.enableInteruptLock(windowName);
                                }
                            },
                            onDisableInterruptLock: function () {
                                if (_this.isEmbeddedApp()) {
                                    _this.runInterruptCallback();
                                }
                                else {
                                    _this.disableInteruptLock(windowName);
                                }
                            },
                            getTerminal: this.options.getTerminal,
                        });
                        // Hook up child window manager events to bubble up to the parent.
                        if (parentWindowManager) {
                            windowManager.on('window_preload_error', function (metadata) {
                                parentWindowManager.emit('window_preload_error', metadata);
                            });
                            windowManager.on('window_play', function (metadata) {
                                parentWindowManager.emit('window_play', metadata);
                            });
                            windowManager.on('window_end_success', function (metadata) {
                                parentWindowManager.emit('window_end_success', metadata);
                            });
                            windowManager.on('window_end_error', function (metadata) {
                                parentWindowManager.emit('window_end_error', metadata);
                            });
                            windowManager.on('window_analytics_event', function (metadata) {
                                parentWindowManager.emit('window_analytics_event', metadata);
                            });
                            windowManager.on('window_charge_request', function (metadata) {
                                parentWindowManager.emit('window_charge_request', metadata);
                            });
                        }
                        this.windowManagers[windowName] = windowManager;
                        windowManager.setRenderer(renderer);
                        return [4 /*yield*/, windowManager.load()];
                    case 2:
                        _b.sent();
                        // The child window manager should be focused instead of the main window when focus() is called
                        // on the main window. Setting focus currently only happens on window create and can't be updated.
                        // This really only exists to support using VR with the remote in MZ. Only one child window can have
                        // focus, the last window to send an open window message wins. Handling focus needs more thought now
                        // that we have Secondscreen. We need to be extra careful about forcing focus in a touch environment.
                        if (isFocused) {
                            this.focusedWindowManager = windowManager;
                        }
                        // If a child window is opened and the presentation is already playing (Kiosk),
                        // play the window after opening it. Otherwise we'll will wait until the presentation
                        // is ready and has received play before playing it.
                        if (this.isPlaying()) {
                            windowManager.play();
                        }
                        else {
                            this.checkIsReadyCallback();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PresentationWindow.prototype.closeChildWindow = function (windowName) {
        var windowManager = this.windowManagers[windowName];
        if (windowManager) {
            windowManager.destroy();
            delete this.windowManagers[windowName];
        }
        else {
            this.logWarning("Failed to close child window manager for '".concat(windowName, "'."));
        }
    };
    // Legacy enable interrupt lock for RaydiantKit apps (ie. Virtual Rooms). This has been
    // replaced by createInterruptLock for embedded apps.
    PresentationWindow.prototype.enableInteruptLock = function (windowName) {
        if (windowName) {
            this.isChildWindowLocked[windowName] = true;
        }
        else {
            this.isWindowLocked = true;
        }
        if (this.isReady() && this.isLocked() && this.enableInterruptLockCallback) {
            this.enableInterruptLockCallback();
        }
    };
    // Legacy disable interrupt lock for RaydiantKit apps (ie. Virtual Rooms). This has been
    // replaced by releaseInterruptLock for embedded apps.
    PresentationWindow.prototype.disableInteruptLock = function (windowName) {
        if (windowName) {
            this.isChildWindowLocked[windowName] = false;
        }
        else {
            this.isWindowLocked = false;
        }
        if (this.isReady() &&
            !this.isLocked() &&
            this.disableInterruptLockCallback) {
            this.disableInterruptLockCallback();
        }
    };
    PresentationWindow.prototype.getEmbeddedAppUrl = function () {
        var _a = this.options, windowId = _a.windowId, appRendererOfflineSupport = _a.appRendererOfflineSupport, device = _a.device;
        var metadata = {
            renderMode: this.getRenderMode(),
        };
        if (device) {
            metadata.deviceId = device.id;
        }
        var url = (0, embeddedApps_1.default)(this.presentation, this.options.applicationVersion, metadata);
        return this.getFullAppRendererUrl({
            appRendererUrl: url,
            windowId: windowId,
            appRendererOfflineSupport: appRendererOfflineSupport,
        });
    };
    PresentationWindow.prototype.handleReady = function () {
        this.didReceiveReady = true;
        this.checkIsReadyCallback();
    };
    PresentationWindow.prototype.handleComplete = function () {
        this.didReceiveComplete = true;
        if (this.completeCallback) {
            this.completeCallback();
        }
    };
    PresentationWindow.prototype.logDebug = function (message) {
        this.options.logger.debug(message, this.getLogContext());
    };
    PresentationWindow.prototype.logInfo = function (message) {
        this.options.logger.info(message, this.getLogContext());
    };
    PresentationWindow.prototype.logWarning = function (message) {
        this.options.logger.warn(message, this.getLogContext());
    };
    PresentationWindow.prototype.logError = function (message) {
        this.options.logger.error(message, this.getLogContext());
    };
    PresentationWindow.prototype.getLogContext = function () {
        var _a = this.options, windowId = _a.windowId, windowName = _a.windowName, parentWindowId = _a.parentWindowId, presentation = _a.presentation, applicationVersion = _a.applicationVersion, publishedAt = _a.publishedAt, playlistId = _a.playlistId, playlistName = _a.playlistName, rule = _a.rule;
        return {
            windowId: windowId,
            windowName: windowName,
            parentWindowId: parentWindowId,
            presentationId: presentation.id,
            presentationName: presentation.name,
            applicationId: applicationVersion.applicationId,
            applicationVersionName: applicationVersion.name,
            applicationVersionId: applicationVersion.id,
            publishedAt: publishedAt,
            playlistId: playlistId,
            playlistName: playlistName,
            rule: rule,
        };
    };
    PresentationWindow.prototype.metadata = function () {
        return this.getLogContext();
    };
    PresentationWindow.prototype.runWorkerSubscriptions = function (state) {
        // For each worker subscription, compare the previous state to the new state.
        // If the state has changed, send the new state to the subscription.
        for (var _i = 0, _a = Array.from(this.workerSubscriptions); _i < _a.length; _i++) {
            var workerName = _a[_i];
            var workerState = state[workerName];
            var previousWorkerState = this.workerState[workerName];
            if (workerState !== undefined &&
                !(0, fast_deep_equal_1.default)(workerState, previousWorkerState)) {
                this.sendMessageString('worker-state', {
                    name: workerName,
                    state: workerState,
                });
            }
        }
        // Persist the new state so we can compare if the previous values have changed..
        this.workerState = state;
    };
    PresentationWindow.prototype.createRuleEngine = function (playlistId) {
        var globalRule = this.options.globalRule;
        return new RE.RuleEngine(playlistId, this.ruleEngineState, globalRule
            ? {
                // Append to the global rule with an AND to filter out other presentations
                // that have playlists. Prevents MZ in MZ, Kiosk in Kiosk, MZ in Kiosk, etc...
                type: 'and',
                group: [
                    globalRule,
                    {
                        type: 'equals',
                        left: { var: ['target', 'hasPlaylists'] },
                        right: { const: false },
                    },
                ],
            }
            : {
                // A global rule was not provided so we don't need to combine the rule with an AND.
                type: 'equals',
                left: { var: ['target', 'hasPlaylists'] },
                right: { const: false },
            });
    };
    PresentationWindow.prototype.isValidOpenChildWindowPayload = function (payload) {
        if (!payload)
            return false;
        if (typeof payload !== 'object')
            return false;
        if (!payload.windowId)
            return false;
        if (!payload.playlistId)
            return false;
        if (!isValidNumber(payload.x))
            return false;
        if (!isValidNumber(payload.y))
            return false;
        if (!isValidNumber(payload.width))
            return false;
        if (!isValidNumber(payload.height))
            return false;
        return true;
    };
    PresentationWindow.prototype.shouldMute = function () {
        if (this.forceMute) {
            return true;
        }
        // Check app vars for muted properties. This is gross because it relies on
        // presentation properties having specific names. A better solution is needed
        // long term.
        var appVars = this.presentation.applicationVariables;
        var hasMuteProp = appVars.mute === true || appVars.muted === true;
        if (hasMuteProp) {
            return true;
        }
        var isMutedMultizone = appVars.muteZone1 === true && appVars.muteZone2 === true;
        return isMutedMultizone;
    };
    PresentationWindow.prototype.createObjectURLForEmbeddedApp = function (blob) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Handle multiple concurrent createObjectURL calls by creating a request id for each
            // call. We send the request id along with the message to the running app and the app
            // sends the request id back with the result so we can resolve the correct promise.
            var requestId = (0, uuid_1.v4)();
            _this.createObjectURLResolvers[requestId] = resolve;
            // Start a timer to reject the promise if the app doesn't respond with the create object
            // url result within 1 second. This should be more or less instant.
            _this.createObjectURLTimeouts[requestId] = setTimeout(function () {
                var error = new Error("Timed out waiting for the create-object-url-result message for request id ".concat(requestId));
                reject(error);
                delete _this.createObjectURLResolvers[requestId];
                delete _this.createObjectURLTimeouts[requestId];
            }, 1000);
            // Create a FileReader object to read the file data as an ArrayBuffer.
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                var buffer = reader.result;
                // Check if buffer is an ArrayBuffer
                if (buffer instanceof ArrayBuffer) {
                    // Send the ArrayBuffer to the running app to create the local file blob URL.
                    _this.sendMessageObject('create-object-url', { requestId: requestId, buffer: buffer });
                }
            }, false);
            reader.readAsArrayBuffer(blob);
            return '';
        });
    };
    PresentationWindow.prototype.createInterruptLock = function () {
        var lockId = (0, uuid_1.v4)();
        var lock = {
            id: lockId,
            expiresAt: +new Date() + lockDuration,
            timeout: this.createLockTimeout(lockId),
        };
        this.interruptLocks[lock.id] = lock;
        this.runInterruptCallback();
        return lock;
    };
    PresentationWindow.prototype.renewInterruptLock = function (id) {
        var lock = this.interruptLocks[id];
        if (lock) {
            // Reset expiration time.
            lock.expiresAt = +new Date() + lockDuration;
            // Reset timeout.
            if (lock.timeout) {
                clearTimeout(lock.timeout);
            }
            lock.timeout = this.createLockTimeout(id);
        }
        else {
            // If the lock doesn't exist it was already released, create a new lock with the same id.
            lock = {
                id: id,
                expiresAt: +new Date() + lockDuration,
                timeout: this.createLockTimeout(id),
            };
            this.interruptLocks[lock.id] = lock;
        }
        this.runInterruptCallback();
        return lock;
    };
    PresentationWindow.prototype.releaseInterruptLock = function (id) {
        var lock = this.interruptLocks[id];
        if (lock) {
            if (lock.timeout) {
                clearTimeout(lock.timeout);
            }
            delete this.interruptLocks[id];
        }
        else {
            // If the lock doesn't exist it was already released, return a fake lock object to
            // send a response back to the running app.
            lock = { id: id, expiresAt: 0, timeout: null };
        }
        this.runInterruptCallback();
        return lock;
    };
    PresentationWindow.prototype.createLockTimeout = function (id) {
        var _this = this;
        return setTimeout(function () {
            _this.logInfo("Interrupt lock expired, releasing: ".concat(id));
            _this.releaseInterruptLock(id);
        }, lockDuration);
    };
    PresentationWindow.prototype.runInterruptCallback = function () {
        var currentlyLocked = this.isLocked();
        // If locked and the lock state has changed, run the interrupt lock callback.
        // Or if not locked and the lock state has changed, run the disable interrupt lock callback.
        if (currentlyLocked &&
            this.previouslyLocked !== currentlyLocked &&
            this.enableInterruptLockCallback) {
            this.enableInterruptLockCallback();
        }
        else if (!currentlyLocked &&
            this.previouslyLocked !== currentlyLocked &&
            this.disableInterruptLockCallback) {
            this.disableInterruptLockCallback();
        }
        this.previouslyLocked = currentlyLocked;
    };
    PresentationWindow.prototype.getRenderMode = function () {
        return this.options.isPreview ? 'preview' : 'live';
    };
    return PresentationWindow;
}());
exports.default = PresentationWindow;
var isValidCreateObjectURLResultPayload = function (payload) {
    return (
    // Ensure payload is an object.
    typeof payload === 'object' &&
        payload !== null &&
        // Ensure requestId is a string.
        'requestId' in payload &&
        typeof payload['requestId'] === 'string' &&
        // Ensure payload.file is an object.
        'url' in payload &&
        typeof payload['url'] === 'string');
};
var transformInputValues = function (inputs) {
    var transformed = {};
    // Recursively traverse inputs, transforming any file input values to remove internal
    // properties like file_upload_id.
    for (var _i = 0, _a = Object.entries(inputs); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (typeof value === 'object' && value !== null && 'url' in value) {
            // Value is a file input, strip out the file_upload_id property.
            transformed[key] = { url: value.url };
        }
        else if (Array.isArray(value)) {
            // Value is an array input, traverse each item in the array for file input values.
            transformed[key] = [];
            for (var _c = 0, value_1 = value; _c < value_1.length; _c++) {
                var item = value_1[_c];
                if (typeof item === 'object' && item !== null) {
                    transformed[key].push(transformInputValues(item));
                }
                else {
                    transformed[key].push(item);
                }
            }
        }
        else {
            transformed[key] = value;
        }
    }
    return transformed;
};
